import { Component, OnInit, ViewChild } from '@angular/core';
import { ProductService } from 'src/app/service/product.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'product-library',
    templateUrl: './product-library.component.html',
    styleUrls: ['./product-library.component.scss'],
    standalone: false
})
export class ProductLibraryComponent implements OnInit {
    @ViewChild('tabGroup', { static: false }) tabGroup: any;
    public selectedIndex = 0;
    productType = 'glazing';
    private baseURL = environment.baseURL;

    constructor(public productService: ProductService) { }

    ngOnInit(): void {
        if (this.productService.initialTab === 'glazing') {
            this.selectedIndex = 0;
        } else if (this.productService.initialTab === 'shading') {
            this.selectedIndex = 1;
        } else {
            console.warn('Unrecognized initialTab.');
        }
    }

    onTabChange() {
        const selectedIndex = this.tabGroup.selectedIndex;
        this.productType = selectedIndex === 0 ? 'glazing' : 'shading';
    }

}